import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/contracts/list', data, {params})
  },
  changeStatus(id, status) {
    return http.put(`/contracts/${id}/status`, null, {params: {status}})
  },
  save(data) {
    return http.post('/contracts', data)
  },
  update(id, data) {
    return http.put(`/contracts/${id}`, data)
  },
  get(id) {
    return http.get(`/contracts/${id}`)
  },
  queryDni(dni) {
    return http.get(`/contracts/dni/${dni}`)
  },
  download(data) {
    return http.post("/contracts/xlsx", data, { responseType: "blob" });
  },
  downloadInsuranceReport(companyId) {
    return http.get("/contracts/insurance-report/xlsx", {
      params: companyId ? { companyId } : {},
      responseType: "blob",
    });
  },
  queryRuc(ruc) {
    return http.get(`/contracts/ruc/${ruc}`)
  },
  cease(id, formData) {
    return http.post(`/contracts/${id}/cease`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  downloadCessationDocument(contractId, documentId) {
    return http.get(`/contracts/${contractId}/cessation-documents/${documentId}`, { responseType: 'blob' })
  },
  uploadCessationDocument(contractId, file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.post(`/contracts/${contractId}/cessation-documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  // DEF-016: reemplaza un documento de cese (archiva el anterior, deja el nuevo activo).
  replaceCessationDocument(contractId, documentId, file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.put(`/contracts/${contractId}/cessation-documents/${documentId}/replace`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  downloadDocument(contractId) {
    return http.get(`/contracts/${contractId}/document`, { responseType: 'blob' })
  },
  uploadSignedDocument(contractId, file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.post(`/contracts/${contractId}/signed-document`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  downloadSignedDocument(contractId) {
    return http.get(`/contracts/${contractId}/signed-document`, { responseType: 'blob' })
  },
  // Documentos generados desde plantilla + historial.
  listDocuments(contractId) {
    return http.get(`/contracts/${contractId}/documents`)
  },
  applicableTemplates(contractId) {
    return http.get(`/contracts/${contractId}/documents/templates`)
  },
  generateDocument(contractId, templateId) {
    return http.post(`/contracts/${contractId}/documents/generate`, { templateId })
  },
  downloadGeneratedDocument(contractId, documentId) {
    return http.get(`/contracts/${contractId}/documents/${documentId}/download`, { responseType: 'blob' })
  },
  uploadEditedDocument(contractId, file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.post(`/contracts/${contractId}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
}
